// extracted by mini-css-extract-plugin
module.exports = {"root":"FullServiceBlade-module--root--3bajm","rowStyle":"FullServiceBlade-module--rowStyle--3Kka9","textColumn":"FullServiceBlade-module--textColumn--1EF8a"};